<script>
export default {
  methods: {
    applyTemplateSlot: function(slot) {
      const vm = this;

      return vm.$store.dispatch("searchTemplates", { slot: slot }).
        then(function(resp) {
          const template_id = resp.data?.data?.template?.id;

          vm.$store.dispatch("applyTemplate", { templateId: template_id, itemId: vm.$store.state.item.id }).
            then(function() {
              // TODO: This can be made into something reactive some day.
              vm.$bvModal.hide("template-modal");
              window.manualReload = true;
              window.location.reload();
            }).catch(function(error){
              vm.$root.toastError(`Could not apply template: ${error.response.data.errors[0].detail}`)
            });
        }).
        catch(function(error) {
          if (error.response?.status == 404) {
            // User has not yet customized, open the sidebar
            vm.$bvModal.hide("template-modal");
            vm.$root.$refs.templateSidebar.loadSidebar(vm.values);
            vm.$root.$refs.templateSidebar.toggleSidebar();
            return;
          }
          vm.$root.toastError(`Failed to apply template: ${error}`);
        });
    }
  }
}
</script>
